import { configureStore } from "@reduxjs/toolkit";
import selectedSpaceReducer from './SelectedSpace';
import planningSliceReducer from './PlanningSpaces'
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// Set up redux-persist configuration
const persistConfig = {
    key: 'root',         // The key used for persistence
    storage,             // Using localStorage
    // whitelist: ['planning']   // Only persist the 'planning' slice of the Redux state
  };
  // Wrap your planning reducer with persistReducer to enable persistence
const persistedPlanningReducer = persistReducer(persistConfig, planningSliceReducer);
const store = configureStore({
    reducer:{
        selectedSpace: selectedSpaceReducer,
        // planning: planningSliceReducer
        planning: persistedPlanningReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
          serializableCheck: {
            // Ignore redux-persist actions
            ignoredActions: [
              "persist/PERSIST",
              "persist/REHYDRATE",
              "persist/REGISTER",
            ],
          },
        }),
})
// Create a persistor to persist the store
export const persistor = persistStore(store);
export default store;